/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { ComposerTab } from 'cio/components/action-composer-v2';
import { InAppPreview } from 'cio/utils/previews';
import {
  ComposerCampaignActionTemplate,
  ComposerNewsletterTemplate,
} from 'cio/utils/composer/composer-editable-entity';

interface InAppEditorSignature {
  Args: {
    editableEntity: ComposerCampaignActionTemplate | ComposerNewsletterTemplate;
    composerTab: ComposerTab;
    preview: InAppPreview | null;
    hasReadOnlyPermission: boolean;
  };
  Element: HTMLDivElement;
}

export default class InAppEditor extends Component<InAppEditorSignature> {}
